import { AwardsModuleDiscover } from '../../../types/components'
import { Media, MediaContextProvider } from '../Media'
import Desktop from './Desktop'
import Phone from './Phone'
import Tablet from './Tablet'

const ModuleDiscoverPagePage = ({
  moduleProps
}: {
  moduleProps: AwardsModuleDiscover['attributes']
}) => {
  return (
    <MediaContextProvider>
      <Media lessThan='md'>
        <Phone {...moduleProps} />
      </Media>
      <Media between={['md', 'lg']}>
        <Tablet {...moduleProps} />
      </Media>
      <Media greaterThanOrEqual='lg'>
        <Desktop {...moduleProps} />
      </Media>
    </MediaContextProvider>
  )
}

export default ModuleDiscoverPagePage
